import {
  CreateEvidenceOptions,
  Evidence,
  EvidenceFormData,
} from "../../evidence.types";

/**
 * Parent linkage for the copy. A child item is copied as another child of the
 * same parent; a top-level item is copied as a top-level item (undefined lets
 * `createEvidence` apply its parent defaults).
 *
 * `is_parent !== 1` rather than `=== 0`: the column is nullable and the API
 * treats NULL as a child, matching the app's other child checks.
 */
export const getCopyCreateOptions = (
  data: Evidence
): CreateEvidenceOptions | undefined => {
  if (data.is_parent !== 1 && data.parent_id) {
    return {
      is_parent: 0,
      parent_id: data.parent_id,
      parent_name: data.parent_name,
    };
  }
  return undefined;
};

export const getCopySourceData = (
  data: Evidence,
  isChildCopy: boolean
): EvidenceFormData => {
  // construct form data, minus the unique identifiers from the source evidence
  const defaultFormData: EvidenceFormData = {
    case_id: data.case_id,
    item_type: data.item_type,
    evi_type_id: data.evi_type_id,
    manufacturer: data.manufacturer,
    model_name: data.model_name,
    model_number: data.model_number,
    serial_number: data.serial_number,
    capacity: data.capacity,
    capacity_unit: data.capacity_unit,
    contact_id: data.contact_id,
    linked_contact: data?.linked_contact?.client_id
      ? {
          value: data.linked_contact.client_id,
          label: data.linked_contact.name,
          data: data.linked_contact,
        }
      : undefined,
    custom_attributes: data.custom_attributes,
    description: data.description,
    // Child copies start with an empty chain of custody; only prefill the
    // intake fields the same way CreateEvidenceChildForm does.
    ...(isChildCopy && {
      custody_from: data.parent_name,
      reason: `Removed from parent ${data.parent_name}`,
    }),
  };

  return defaultFormData;
};
